import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <CardsSection />
        <FeaturesSection />
        <IndexSection />
        <TopicsSection />
        <FaqSection />
        <UpdatesSection />
        <RankingSection />
        <AboutSection />
        <CommentsSection />
        <CarouselSection />
        <ContactSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}